import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { EMultipleAuthViewMode } from '../core/security-authentication.enum';
import { BzgModalService } from 'bz-genome-angular';
import { DeleteConfirmationComponent } from 'app/shared/components/delete-confirmation/delete-confirmation.component';
import {
  trigger,
  state,
  style,
  animate,
  transition
} from '@angular/animations';
import { SetCurrentAuthenticator } from '../store/actions/authentication.actions';
import { Store } from '@ngrx/store';
import { IAppState } from 'app/IAppState';
import { MultipleAuthenticator } from '../core/authentication-contracts';

export enum ListViewMode {
  active = 'active',
  deactive = 'deactive'
}

@Component({
  selector: 'biz-multiple-auth-list',
  templateUrl: './multiple-auth-list.component.html',
  styleUrls: ['./multiple-auth-list.component.scss'],
  animations: [
    trigger('slideListUnselect', [
      state(
        'void',
        style({
          opacity: 0,
          transform: 'translateX(-100%)'
        })
      ),
      transition('void <=> *', animate(300))
    ]),
    trigger('slideListSelect', [
      state(
        'void',
        style({
          opacity: 0,
          transform: 'translateX(-100%)'
        })
      ),
      transition('void <=> *', animate(300))
    ])
  ]
})
export class MultipleAuthListComponent implements OnInit {
  private _packToEmit: {};

  public selectedMethod: any;
  public searchValue: any;
  public selectedOptionsMetadata: any;
  public selectedFlow: any;
  public deleteActivated: Boolean = false;
  public deletionArray: Array<any> = [];
  public unSelectListStatus = ListViewMode.active;

  @Input() authenticatorList: { type: string, authenticators: Array<MultipleAuthenticator> };
  @Input() viewMode: EMultipleAuthViewMode;
  @Input() isEditable = true;
  @Input() multipleOptionsMetadata: Array<any>;
  @Input() currentAuthenticator: MultipleAuthenticator;
  @Input() metadata: { [key: string]: any };


  @Output() onChangeViewMode = new EventEmitter();
  @Output() onSelectOption = new EventEmitter();
  @Output() onSelectOAuthOption = new EventEmitter();
  @Output() onDeleteAuthenticators = new EventEmitter();

  constructor(private _modalService: BzgModalService, private _store: Store<IAppState>) { }

  ngOnInit() { }

  updateSelectedOptionsMetadata() {
    this.selectedOptionsMetadata = null;
    this.selectedFlow = null;
    if (this.currentAuthenticator && this.currentAuthenticator.type) {
      if (this.multipleOptionsMetadata) {
        const selectedMetadata = this.multipleOptionsMetadata.find(
          element =>
            element.type === this.currentAuthenticator.type &&
            element.subtype === this.currentAuthenticator.subtype
        );

        if (this.currentAuthenticator.type === 'OAuth2') {
          this.selectedOptionsMetadata = _.cloneDeep(
            selectedMetadata.oauthOptions[
            this.currentAuthenticator.oauthOptions.activeFlow
            ]
          );
        } else {
          this.selectedOptionsMetadata = selectedMetadata ? _.cloneDeep(selectedMetadata.options) : {};
        }
      }

      if (this.currentAuthenticator.type === 'OAuth2') {
        this.selectedFlow = _.find(
          this.currentAuthenticator.oauthOptions.flows,
          flow =>
            flow.name === this.currentAuthenticator.oauthOptions.activeFlow
        );
      }
    }
  }

  ngOnChanges() {
    this.updateSelectedOptionsMetadata();
  }

  changeToUnselectMode() {
    this.onChangeViewMode.emit({ mode: EMultipleAuthViewMode.Unselect });
  }

  addAuthenticator() {
    this.onChangeViewMode.emit({ mode: EMultipleAuthViewMode.Add });
  }

  setSelectedAuthenticator(authenticator, event) {
    if (!this.deleteActivated) {
      this._packToEmit = {
        mode: EMultipleAuthViewMode.Edit,
        authenticator
      };
    }
    this.currentAuthenticator = authenticator;
    this._store.dispatch(new SetCurrentAuthenticator(authenticator));
    event.stopPropagation();
    this.unSelectListStatus = ListViewMode.deactive;
  }

  public emitAfterAnimation() {
    if (this._packToEmit) {
      this.onChangeViewMode.emit(this._packToEmit);
    }
  }

  public showListAfterAnimation() {
    if (this.viewMode === EMultipleAuthViewMode.Unselect) {
      this.unSelectListStatus = ListViewMode.active;
      this._packToEmit = null;
      this.changeToUnselectMode();
    }
  }

  selectOption($event) {
    this.onSelectOption.emit($event);
  }

  selectOAuthOption($event) {
    this.onSelectOAuthOption.emit($event);
  }

  public cancelDeletion() {
    this.deleteActivated = false;
    this.deletionArray = [];
  }

  public showDeleteConfirmation() {
    const modal = this._modalService.open(DeleteConfirmationComponent, {
      closeOnBackdropClick: false,
      closeOnRouterNavigation: true,
      data: {
        title: 'AUTHENTICATION.DELETE_AUTHENTICATORS',
        message: 'AUTHENTICATION.CONFIRM_DELETE',
        button: 'AUTHENTICATION.DELETE_OK_BUTTON'
      }
    });
    modal.afterClosed().subscribe((result: string) => {
      if (result === 'delete') {
        this._deleteAuthenticators();
      }
    });
  }

  private _deleteAuthenticators() {
    this.onDeleteAuthenticators.emit(this.deletionArray);
    this.deleteActivated = false;
    this.deletionArray = [];
  }

  public addOrRemoveFromDeletionList(authenticator: any, checked: boolean) {
    if (typeof checked === 'boolean') {
      if (checked) {
        this.deletionArray.push(authenticator);
      } else {
        _.remove(this.deletionArray, item => item === authenticator);
      }
    }
  }

  public isDisabled(authenticator?: MultipleAuthenticator): boolean {
    if (!authenticator) {
      authenticator = this.currentAuthenticator;
    }
    if (authenticator.subtype) {
      return this.metadata && (!this.metadata[authenticator.type] || !this.metadata[authenticator.type].options[authenticator.subtype]);
    } else {
      return this.metadata && !this.metadata[authenticator.type];
    }
  }

}
